import { Tile } from "ol/layer";
import XYZ from "ol/source/XYZ";
import TileGrid from "ol/tilegrid/TileGrid";
import { ServerLayer } from "../../../lib/layers";
import { Some } from "../../../lib/misc/option";
export class TileLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    validate(opts) {
        let result = true;
        result && (result = typeof opts.infoUrl === 'string');
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = opts.isBaseLayer !== undefined && opts.visible !== undefined);
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    async parse_config(opts) {
        const api = await this.get_service_api(opts.exportUrl);
        if (!api.is_cached)
            throw new Error("Tile layer did not have an active tile cache: [" + opts.name + "]");
        const layer = new Tile({
            extent: api.extent,
            opacity: opts.opacity,
            visible: opts.visible,
            source: new XYZ({
                urls: api.endpoints.map((u) => u + '/tile/{z}/{y}/{x}'),
                crossOrigin: 'anonymous',
                projection: api.projection,
                tileGrid: new TileGrid({
                    extent: api.extent,
                    origin: api.origin,
                    tileSize: api.tile_size,
                    resolutions: api.cached_resolutions
                })
            })
        });
        this.raw = new Some(layer);
        this.is_base = opts.isBaseLayer;
        this.name = opts.name;
        this.projection = api.projection;
    }
}
